import { Component } from '@angular/core';
import { ToastService } from '../../services/premium-toast.service';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss']
})
export class ToastContainerComponent {
  constructor(public toast: ToastService) {}

  trackById = (_: number, t: { id: string }) => t.id;
}
